export const adminRoutes = {
  surveyExport: "survey/:id",
} as const;
